import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg_icon = _resolveComponent("base-svg-icon")!

  return (_openBlock(), _createElementBlock("button", {
    type: "submit",
    disabled: _ctx.disabled,
    class: _normalizeClass(`${_ctx.color} py-1.5 px-4 rounded disabled:opacity-75`)
  }, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.disabled)
        ? (_openBlock(), _createBlock(_component_base_svg_icon, {
            key: 0,
            class: "w-6 animate-spin mr-1 p-0.5",
            path: _ctx.mdiLoading
          }, null, 8, ["path"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.text), 1)
    ])
  ], 10, _hoisted_1))
}